$(document).ready(function () {
	/* Menu - Open/Close */
	/* -------------------------------------------------------------------------------------- */
	$('.js-open-menu').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this),
			item = $(el.attr('data-open'));
		item.removeClass('d-none');
	});

	$('.js-close-menu').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this),
			item = $(el.attr('data-close'));
		item.addClass('d-none');
	});

	/* Inputs - Forms */
	/* -------------------------------------------------------------------------------------- */
	// General
	$('form :input').focus(function(event) {
		/* Act on the event */
		var el = $(this);
		el.closest('.c-form__group').addClass('focus-group');
		el.closest('.c-form-search__group').addClass('focus-group');
		el.closest('.c-form__group').find('.input-error').removeClass('input-error');
	});

	$('form :input').keyup(function(event) {
		/* Act on the event */
		var el = $(this);
		el.closest('.c-form__group').addClass('focus-group');
		el.closest('.c-form-search__group').addClass('focus-group');
		el.closest('.c-form__group').find('.input-error').removeClass('input-error');
	});

	$('form :input').focusout(function(event) {
		/* Act on the event */
		var el = $(this);
		if ( el.val() == '') {
			el.closest('.c-form__group').removeClass('focus-group');
			el.closest('.c-form-search__group').removeClass('focus-group');
		}
		if(el.attr('name') == 'contact[phone]'){
			var input_phone = el.val(),
				expRegular_phone = new RegExp(/^\d{10}$/);
			if (expRegular_phone.test(input_phone) == false){
				el.closest('.c-form__group').addClass('group-error');
				el.closest('.c-form').find('#button-contact').attr('disabled', 'disable');
			}else{
				el.closest('.c-form__group').removeClass('group-error');
				el.closest('.c-form').find('#button-contact').removeAttr('disabled');
			}
		}
	});

	$('form .c-form__input[type=text]').each(function() {
		var el = $(this);
		if (el.val().length > 0) {
			el.closest('.c-form__group').addClass('focus-group');
			el.closest('.c-form-search__group').addClass('focus-group');
		}
	});

	// Password
	$(".js-view").click(function() {
		var el = $(this),
			input = el.siblings('.js-input');
		input.focus();
		input.toggleClass('active');
		
		if( input.hasClass('active')){
			if (input.attr("type") == "password") {
				input.attr("type", "text");
				el.addClass('active');
			}
		}
	});

	$(".js-input").focusout(function(event) {
		var el = $(this),
			btn = el.siblings('.js-view');
		btn.removeClass('active');
		if (el.attr("type") == "text") {
			el.attr("type", "password");
		}
	});

	$('#register_email').focusout(function(event) {
		/* Act on the event */
		var el = $(this),
			value = el.val(),
			string = new RegExp(/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/);
		if (string.test(value) == false){
        	el.closest('.c-form__group').addClass('group-error');
        	el.closest('.c-register').find('#button-register').attr('disabled', 'disable');
		}else{
			var doms = ["aerobal.com","bussie.com.co","corex.com.mx","gridimex.com.mx","grimann.com.mx","grupoidisa.com","hormona.com.mx","invekra.com.mx","labinco.com.co","laboratoriosportugal.com","litogrimann.com.mx","morepharmacorp.com","pharmadorf.com","pharmaservicios.com","sanfer.cl","sanfer.com.co","sanfer.com.ec","sanfer.com.mx","sanfer.com.pa","sanferchile.cl","sanfercontigo.com","sanferdigital.onmicrosoft.com"];
			var filters = doms.filter(function(dom) {
				return value.includes(dom);
			});
	        if (filters.length > 0) {
	        	el.closest('.c-form__group').removeClass('group-error');
		        el.closest('.c-form__group').addClass('group-success');
		        el.closest('.c-register').find('#button-register').removeAttr('disabled');
	        }else {
	        	el.closest('.c-form__group').addClass('group-error');
        		el.closest('.c-register').find('#button-register').attr('disabled', 'disable');
	        }
	    }
	});

	/* Slick General */
	/* -------------------------------------------------------------------------------------- */
	$('[data-slider=slick]').each(function() {
		var slider = $(this),
			slides = slider.find('.js-slides'),
			btnPrev = slider.find('.js-btn-prev'),
			btnNext = slider.find('.js-btn-next'),
			mobile = slider.attr("data-mobile") || 2,
			desktop = slider.attr("data-desktop") || 4,
			appendDots = slider.find('.c-slider__dots'),
			centerMode = (slider.attr("data-center-mode") == 1 ) ? true : false,
			dotsMobile = (slider.attr("data-dots-mobile") == 1 ) ? true : false,
			dotsDesktop = (slider.attr("data-dots-desktop") == 1 ) ? true : false,
			fade = (slider.attr("data-fade") == 1 ) ? true : false;

		slides.slick({
			centerMode: centerMode,
			dots: dotsDesktop,
			infinite: true,
			fade: fade,
			slidesToShow: desktop,
			slidesToScroll: 1,
			speed: 300,
			autoplay: true,
			autoplaySpeed: 10000,
			arrows: true,
			prevArrow: btnPrev,
			nextArrow: btnNext,
			appendDots: appendDots,
			responsive: [
				{
					breakpoint: 1023,
					settings: {
						dots: dotsDesktop,
						slidesToShow: desktop,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 769,
					settings: {
						dots: dotsDesktop,
						slidesToShow: desktop,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 480,
					settings: {
						arrows: false,
						dots: dotsMobile,
						slidesToShow: mobile,
						slidesToScroll: 1
					}
				}
			]
		});
	});

	/* Product - Recommendations */
	/* -------------------------------------------------------------------------------------- */
	setTimeout(function(){

		$('[data-slider=slick-recommendations]').each(function() {
			var slider = $(this),
				slides = slider.find('.js-slides'),
				btnPrev = slider.find('.js-btn-prev'),
				btnNext = slider.find('.js-btn-next'),
				mobile = slider.attr("data-mobile") || 2,
				desktop = slider.attr("data-desktop") || 4,
				appendDots = slider.find('.c-slider__dots'),
				centerMode = (slider.attr("data-center-mode") == 1 ) ? true : false,
				dotsMobile = (slider.attr("data-dots-mobile") == 1 ) ? true : false,
				dotsDesktop = (slider.attr("data-dots-desktop") == 1 ) ? true : false,
				fade = (slider.attr("data-fade") == 1 ) ? true : false,
				autoplaySpeed = slider.attr("data-speed") || 10000;

			slides.slick({
				centerMode: centerMode,
				dots: dotsDesktop,
				infinite: true,
				fade: fade,
				slidesToShow: desktop,
				slidesToScroll: 1,
				speed: 300,
				autoplay: true,
				autoplaySpeed: 10000,
				arrows: true,
				prevArrow: btnPrev,
				nextArrow: btnNext,
				appendDots: appendDots,
				responsive: [
					{
						breakpoint: 1023,
						settings: {
							dots: dotsDesktop,
							slidesToShow: desktop,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 769,
						settings: {
							dots: dotsDesktop,
							slidesToShow: desktop,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 480,
						settings: {
							arrows: false,
							dots: dotsMobile,
							slidesToShow: mobile,
							slidesToScroll: 1
						}
					}
				]
			});
		});
	}, 3000);

	/* Accordion mini */
	/* -------------------------------------------------------------------------------------- */
	$('.js-accordion').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this);
		el.closest('.js-accordion-content').find('.js-accordion-item').toggleClass('show-body');
		el.closest('.js-accordion-content').siblings('.js-accordion-content').find('.js-accordion-item').removeClass('show-body');
	});

	$('.js-accordion-sp').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this);
		el.closest('.js-accordion-item').toggleClass('show-body');
	});

	/* Tabs mini */
	/* -------------------------------------------------------------------------------------- */
	$('#js-nav-tabs .js-min-nav-item .js-min-nav-link').on('click', function(event) {
		event.preventDefault();
		var el = $(this),
			li = el.closest('.js-min-nav-item'),
			target = $( el.attr('href') );
		li.find('.js-min-nav-link').addClass('active').closest('.js-min-nav-item').siblings('.js-min-nav-item').find('.js-min-nav-link').removeClass('active');
		target.addClass('active').siblings('.js-mini-tab-pane').removeClass('active');
	}).first().trigger('click');

	/* Tabs Home */
	/* -------------------------------------------------------------------------------------- */
	$('#js-nav-tabs-home .js-nav-item .nav-link').on('click', function(e) {
		e.preventDefault();
		var el = $(this),
			li = el.closest('.js-nav-item'),
			target = $( el.attr('href') ),
			slider = target.find('[data-slider=sliderTabs]'),
			slides = slider.find('.js-slides-tab'),
			btnPrev = slider.find('.js-btn-prev'),
			btnNext = slider.find('.js-btn-next'),
			mobile = slider.attr("data-mobile") || 2,
			desktop = slider.attr("data-desktop") || 4,
			appendDots = slider.find('.c-slider__dots'),
			status = slider.find('.js-pagingInfo'),
			slide_sibling = target.siblings('.js-tab-pane').find('js-slides-tab');

		li.find('.nav-link').addClass('active').closest('.js-nav-item').siblings('.js-nav-item').find('.nav-link').removeClass('active');
		target.addClass('active').siblings('.js-tab-pane').removeClass('active');

		if (slides.hasClass('slick-initialized')) {
			slides.slick('destroy');
		}
		
		slides.imagesLoaded(function() {

			slides.slick({
				infinite: true,
				speed: 300,
				slidesToShow: desktop,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 8000,
				prevArrow: btnPrev,
				nextArrow: btnNext,
				dots: true,
				appendDots: appendDots,
				responsive: [
					{
						breakpoint: 1023,
						settings: {
							slidesToShow: desktop,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 769,
						settings: {
							slidesToShow: desktop,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: mobile,
							dots: true,
							slidesToScroll: 1
						}
					}
				]
			});
		});
	}).first().trigger('click');

	/* Add to cart - Collections */
	/* -------------------------------------------------------------------------------------- */
	$("body").on('click', '.js-add-cart', function(event) {
		event.preventDefault();
        event.stopPropagation();
		var el = $(this),
			params = el.closest('.js-product-content').find('#product-details'),
			id_value = parseFloat(params.attr("data-product-first-variant")),
			counter = $('.s-site-header-cart--count');
		counter.addClass('active');
		el.find('.js-button-icon').removeClass('d-none');
		el.find('.js-button-text').addClass('d-none');
		$('.c-cart-popup').find('.js-set-inicial').empty();
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: {
				quantity: params.attr("data-product-quantity"),
				id: params.attr("data-product-first-variant")
			},
			dataType: 'json',
			success: function(){
				counter.removeClass('active');
				el.addClass('active');
				el.find('.js-button-text').removeClass('d-none');
				el.find('.js-button-icon').addClass('d-none');
				$.getJSON('/cart.js').then(
			        function(cart) {
			        	counter = $('.s-site-header-cart--count').attr('data-header-cart-count', cart.item_count);
			        	$('.s-site-header-cart--count').addClass('visible');
			        	var items = cart.items;
			        	var index = items.findIndex(item => item.id === id_value );
			        	if (index != -1) {
				        	var cart_total = cart.total_price,
				        		total_divide = numeral(cart_total).divide(100),
				        		total_format = numeral(total_divide).format('$0,0.00'),
				        		cart_title = items[index].product_title,
				        		cart_price = items[index].price,
				        		price_divide = numeral(cart_price).divide(100),
				        		price_format = numeral(price_divide).format('$0,0.00'),
				        		cart_image = "url('" + items[index].image + "')",
				        		cart_vendor = items[index].vendor, 
				        		cart_quantity = items[index].quantity;
		        			params.attr("data-product-quantity-cart", cart_quantity);
				        	params.attr("data-product-line", index + 1);
				        	$('[data-product-subtotal-popup]').append(total_format);
				        	$('[data-product-title-popup]').append(cart_title);
				        	$('[data-product-price-popup]').append(price_format);
				        	$('[data-product-image-popup]').append('<div class="c-cart-popup__product-image" style="background: white '+cart_image+'no-repeat center center; background-size: contain;"></div>');
				        	$('[data-product-vendor-popup]').append(cart_vendor);
				        	$('.c-cart-popup').addClass('visible').parent().addClass('d-block');
				        }
			        }
			    );
			},
			error: function() {
				el.find('.js-button-icon').addClass('d-none');
				el.find('.js-button-text').removeClass('d-none');
				el.prev('.c-card-product__error').removeClass('d-none');
				$('.c-cart-popup').removeClass('visible').parent().removeClass('d-block');
			}
		});
	});

	$('.js-close-cart-popup').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this);
		el.closest('.c-cart-popup').removeClass('visible').parent().removeClass('d-block');
	});

	/* Add to cart - Collections */
	/* -------------------------------------------------------------------------------------- */
	$('.js-button-down').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this);
		el.toggleClass('active');
		el.siblings('.js-button-down-content').toggleClass('active');
	});

	/* Add to cart - Collections */
	/* -------------------------------------------------------------------------------------- */
	$('#product-quantity-input').change(function(event) {
		/* Act on the event */
		var el = $(this);
			value = el.val();
		if( value == 10){
			el.closest('.form-field--qty-input').siblings('.c-label-quantity').removeClass('d-none');
			el.addClass('focus');
		}
	});

	$('.password-header-lock').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		console.log('click');
		$('.passwordentry-container').addClass('active');
	});

	$('.js-close-passwordentry').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		$('.passwordentry-container').removeClass('active');
	});
});